import { render } from "./ContactsEntitySummary.vue?vue&type=template&id=c19ccc5c"
import script from "./ContactsEntitySummary.vue?vue&type=script&lang=js"
export * from "./ContactsEntitySummary.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__